import React from 'react';
import styled from 'styled-components';

const ModalDialog = styled.div`
  position: fixed;
  left: ${props => props.position === 'left' ? (props.moveLeft ? '10px' : '50%') : props.position === 'right' ? 'auto' : '50%'};
  right: ${props => props.position === 'right' ? '0px' : 'auto'};
  top: 50%;
  transform: ${props => {
    if (props.position === 'left') {
      return props.moveLeft ? 'translateY(-50%)' : 'translate(-50%, -50%)';
    } else if (props.position === 'right') {
      return 'translateY(-50%)';
    }
    return 'translate(-50%, -50%)';
  }};
  width: ${props => props.width || '600px'};
  max-width: 90vw;
  height: auto;
  max-height: 80vh;
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  z-index: ${props => props.zIndex || 9998};
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  transition: all 0.3s ease;

  .modal-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 16px;
    border-radius: 12px 12px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    pointer-events: auto;
  }

  .modal-title {
    font-weight: 700;
    font-size: 16px;
    pointer-events: none;
  }

  .close-btn {
    background: none;
    border: none;
    color: white;
    font-size: 24px;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: auto;

    &:hover {
      opacity: 0.8;
    }
  }

  .modal-body {
    background: #f8f9fb;
    padding: 16px;
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
    min-height: 0;
    pointer-events: auto;
  }

  .modal-footer {
    background: white;
    padding: 12px 16px;
    border-top: 1px solid #e0e0e0;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    flex-shrink: 0;
    border-radius: 0 0 12px 12px;
  }
`;

const Modal = ({ title, onClose, children, footer, position = 'center', width = '600px', zIndex = 9998, moveLeft = false }) => (
  <ModalDialog position={position} width={width} zIndex={zIndex} moveLeft={moveLeft}>
    <div className="modal-header">
      <div className="modal-title">{title}</div>
      <button className="close-btn" onClick={onClose}>
        ✕
      </button>
    </div>
    <div className="modal-body">
      {children}
    </div>
    {footer && <div className="modal-footer">{footer}</div>}
  </ModalDialog>
);

export default Modal;
export { ModalDialog };
